import { LOCALES, currencyFor, tr, useI18n, type Locale } from '../lib/i18n';
import { Card, Icon } from './ui';

function LocalePicker({ className = '' }: { className?: string }): JSX.Element {
  const { locale, setLocale } = useI18n();
  return (
    <select
      className={`nl-input ${className}`}
      value={locale}
      aria-label={tr('Idioma')}
      onChange={(event) => setLocale(event.target.value as Locale)}
    >
      {LOCALES.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

/** Seletor compacto para o rodapé do site público. */
export function LanguageSelect(): JSX.Element {
  const { locale, setLocale } = useI18n();
  return (
    <label className="inline-flex items-center gap-2 text-sm">
      <Icon name="globe" size={16} />
      <span className="sr-only">{tr('Idioma')}</span>
      <select
        value={locale}
        aria-label={tr('Idioma')}
        className="rounded-full border border-line bg-card px-3 py-1.5 text-sm text-graphite outline-none focus:border-accent"
        onChange={(event) => setLocale(event.target.value as Locale)}
      >
        {LOCALES.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}

/** Cartão de idioma e moeda para as configurações. */
export function LanguageCard(): JSX.Element {
  const { locale } = useI18n();
  const currency = currencyFor(locale);
  return (
    <Card as="section">
      <h2 className="mb-1 text-lg font-semibold">{tr('Idioma e moeda')}</h2>
      <p className="mb-3 text-sm text-muted">
        {tr('A interface muda para o idioma escolhido e os valores passam a aparecer na moeda correspondente.')}
      </p>
      <LocalePicker className="max-w-xs" />
      <p className="nl-hint mt-3">
        {tr('O mesmo número é mantido e apenas o símbolo e o formato da moeda mudam. Não há conversão pela cotação do dia.')}
      </p>
      {currency !== 'BRL' ? (
        <p className="nl-hint mt-1">
          {tr('A cobrança da assinatura continua sendo processada em reais (BRL), na mesma conta.')}
        </p>
      ) : null}
    </Card>
  );
}

/** Aviso de exibição usado onde há preços. */
export function CurrencyNote({ className = '' }: { className?: string }): JSX.Element | null {
  const { locale } = useI18n();
  const currency = currencyFor(locale);
  if (currency === 'BRL') return null;
  return (
    <p className={`nl-hint ${className}`}>
      {tr('Valores exibidos em {currency} apenas para leitura: a cobrança é processada em reais (BRL).', { currency })}
    </p>
  );
}
